import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalConfigurationReligionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Religion/ReligionBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalConfigurationReligion"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalConfigurationReligion"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalConfigurationReligionActivity)
